export class PageHistoryVersion {
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.reason = model.reason;
        this.restoredFromVersionId = (_a = model.restoredFromVersionId) !== null && _a !== void 0 ? _a : null;
        this.authors = model.authors;
        this.publishedAt = model.publishedAt ? new Date(model.publishedAt) : null;
        this.publishedByUserId = (_b = model.publishedByUserId) !== null && _b !== void 0 ? _b : null;
        this.name = model.name;
    }
}
export class PageHistoryVersionContent {
    constructor(model) {
        this.id = model.id;
        this.jsonContent = model.jsonContent;
    }
}
